<template>
    <div @click="clicked">
        <slot />
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ACooldown',
    props: {
        cooldown: {type: String, required: true},
        enabled: {type: Boolean, default: true},
    },

    data() {
        return {
            hasTriggered: false,
        };
    },

    inject: {
        triggerCooldownUrl: {type: String},
    },

    methods: {
        clicked() {
            if (this.enabled) {
                this.trigger();
            }
        },

        async trigger() {
            if (this.hasTriggered) {
                return;
            }

            this.hasTriggered = true;
            const url = new URL(this.triggerCooldownUrl);
            url.searchParams.set('name', this.cooldown);
            await axios.get(url.toString());
        },
    }
}
</script>
